import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import api from '@/shared/api';
import config from '@/config';
import EditableSelect from './EditableSelect';
const EditablePriceGridSelect = ({ value = null, onChange, required = false, readOnly = false, placeholder = null, }) => {
    const intl = useIntl();
    const [options, setOptions] = useState([]);
    useEffect(() => {
        api.base.get(`${config.appUrls.api}/api/price/Grid`).then(({ data }) => {
            setOptions((data || [])
                .map((x) => ({
                id: x.id,
                label: x.name,
            }))
                .sort(dynamicSort('label')));
        });
    }, []);
    return (_jsx(EditableSelect, { value: value, options: options, onChange: onChange, required: required, readOnly: readOnly, placeholder: placeholder }));
};
export default EditablePriceGridSelect;
